import  { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CustomToast, SuspenseSpinner } from './components/globalComponents';

function App() {
  return (
    <div className="App">
      {/* <ToastContainer onClose={() => dispatch(removeAlert())} /> */}
      <Suspense fallback={<SuspenseSpinner/>}>
        {/* <BrowserRouter>
         
        </BrowserRouter> */}
        <CustomToast />
        <Outlet/>
      </Suspense>
    </div>
  );    
}

export default App;
